import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as upcomingProductsFromSomeoneElseState from '../employee-detail.reducer';
import * as upcomingProductsFromSomeoneElseReducer from '../reducers/upcoming-products-from-someone-else.reducer';

export const getUpcomingProductsFromSomeoneElse = createSelector(
  upcomingProductsFromSomeoneElseState.getUpcomingProductsFromSomeoneElseState,
  upcomingProductsFromSomeoneElseReducer.getUpcomingProductsFromSomeoneElseResponse
);
